const MobileOnlyPage = () => {
    return ( 
        <div className="desktop-message">
            <p>This is a mobile-only app.</p>
        </div> 
  );
}
 
export default MobileOnlyPage;